// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  fromTask as _fromTask,
  percentage as _percentage
} from 'rxfire/storage';

export const fromTask = ɵzoneWrap(_fromTask, true);
export const percentage = ɵzoneWrap(_percentage, true);
